import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/throw';
import { ErrorHandlerProvider } from "../providers/errorHandler.provider";
import { Router } from "@angular/router";

@Injectable()
export class HttpClient {

  baseUrl: string = environment.apiBaseUrl;
  headers: Headers;
  options: RequestOptions;
  authToken: string = "";

  constructor(private http: Http, private errorHandler: ErrorHandlerProvider, private router: Router) { }

  private getHeaders(cacheType?: string) {
    this.authToken = this.getToken();
    this.headers = this.authToken !== null ? new Headers({ 'Authorization': 'Bearer ' + this.authToken }) : new Headers({});
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Redis', cacheType);
    this.options = new RequestOptions({ headers: this.headers });
    return this.options;
  }

  private getToken() {
    var userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    if (userFromLocalStorage !== null)
      return userFromLocalStorage.token;
    return null;
  }

  export(endPoint: String) {
    window.open(this.baseUrl + '/export' + endPoint);
  }

  get(endPoint: String, filter: String = '', cacheType?: string) {
    const headers = this.getHeaders(cacheType);
    return this.http
      .get(this.baseUrl + endPoint + filter, headers)
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        let route = this.router.url.split('/')[1];
        if(route && route == 'purchase-orders') {
            this.errorHandler.interceptError(error, 'operacional')
            this.router.navigate([`/${route}`])
            return Observable.throw(error);
        }
        return Observable.throw(error);
      })
      .toPromise();
  }

  getById(endPoint: String, id: String) {
    const headers = this.getHeaders();
    return this.http
      .get(this.baseUrl + endPoint + '/' + id, headers)
      .map((res: Response) => res.json())
      .toPromise()
      .catch((error: any) => error.json() || 'Server error');
  }

  update(endPoint: String, id, body) {
    const headers = this.getHeaders();
    return this.http
      .put(this.baseUrl + endPoint + '/' + id, JSON.stringify(body), headers)
      .map((res: Response) => res.json())
      .toPromise()
      .catch((error: any) => error || 'Server error');
  }

  post(endPoint: String, body) {
    const headers = this.getHeaders();
    return this.http
      .post(this.baseUrl + endPoint, JSON.stringify(body), headers)
      .map((res: Response) =>  res.json())
      .toPromise()
      .catch((error: any) => error || 'Server error');
  }

  postFile(endPoint: String, body, keyFlag?: string) {
    let headers = this.getHeaders();
    headers.headers.delete('Content-Type');

    //Flag enviada para carga de aprovações afim de substituir valores ou não
    if (keyFlag) headers.headers.append('override', keyFlag);
    return this.http
      .post(this.baseUrl + endPoint, body, headers)
      .map((res: Response) => res.json())
      .toPromise()
      .catch((error: any) => error || 'Server error');
  }

  patch(endPoint: String, body) {
    const headers = this.getHeaders();
    return this.http
      .patch(this.baseUrl + endPoint, JSON.stringify(body), headers)
      .map((res: Response) => res.json())
      .toPromise()
      .catch((error: any) => error || 'Server error');
  }

  delete(endPoint: String, id: String) {
    const headers = this.getHeaders();
    return this.http
      .delete(this.baseUrl + endPoint + '/' + id, headers)
      .map((res: Response) => res.json())
      .toPromise()
      .catch((error: any) => error.json() || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/wrappers/HttpClient.ts